const defaultPagination = () => {
    return {
        page: 1,
        amount: 20
    };
};

export default {
    namespaced: true,
    state: {
        pagination: defaultPagination()
    },
    getters: {
        getPagination: (state) => state.pagination
    },
    mutations: {
        setPagination (state, payload) {
            state.pagination.page = payload.page;
            state.pagination.amount = payload.amount;
        },
        clearPagination (state) {
            state.pagination = defaultPagination();
        }
    },
    actions: {
        savePaginationParamsToStorage (context, pagination) {
            localStorage.setItem('page', pagination.page);
            localStorage.setItem('amount', pagination.amount);
        },
        clearPaginationParamsFromStorage (context) {
            localStorage.removeItem('page');
            localStorage.removeItem('amount');
        },
        getPaginationParamsFromStorage (context) {
            if (localStorage.getItem('page') && localStorage.getItem('amount')) {
                const pagination = {
                    page: parseInt(localStorage.getItem('page')),
                    amount: parseInt(localStorage.getItem('amount'))
                };
                context.commit('setPagination', pagination);
            }
        }
    }
};
